export default () => ({
  sections: [],
  sectionsForm: [],
  section: {},
});
